import type { DefaultRootState } from "react-redux";

export const getAllAclUsers = (state: DefaultRootState) =>
  state.acl.users.content;
export const selectTotalAclUsers = (state: DefaultRootState) =>
  state.acl.users.total;
export const selectHasMoreUsers = (state: DefaultRootState) =>
  state.acl.users.startIndex + state.acl.users.count < state.acl.users.total;
export const getGroups = (state: DefaultRootState) => state.acl.groups;
export const getRoles = (state: DefaultRootState) => state.acl.roles;
export const getSelectedUser = (state: DefaultRootState) =>
  state.acl.selectedUser;
export const getSelectedGroup = (state: DefaultRootState) =>
  state.acl.selectedGroup;
export const getSelectedRole = (state: DefaultRootState) =>
  state.acl.selectedRole;
export const getRoleAssigneesData = (state: DefaultRootState) =>
  state.acl.roleAssignees;
export const getAclIsLoadingRoleAssignees = (state: DefaultRootState) =>
  state.acl.isLoadingRoleAssignees;
export const getAclIsLoadingMoreRoleAssignees = (state: DefaultRootState) =>
  state.acl.isLoadingMoreRoleAssignees;
export const getHasRoleAssigneesError = (state: DefaultRootState) =>
  state.acl.hasRoleAssigneesError;
export const getHasMoreRoleAssigneesError = (state: DefaultRootState) =>
  state.acl.hasMoreRoleAssigneesError;
export const selectHasMoreRoleAssignees = (state: DefaultRootState) => {
  const roleAssignees = state.acl.roleAssignees;

  if (!roleAssignees || roleAssignees.defaultRoleForAllUsers) {
    return false;
  }

  return (roleAssignees.assignees?.length || 0) < (roleAssignees.total || 0);
};
export const getAclIsLoading = (state: DefaultRootState) => state.acl.isLoading;
export const getAclIsLoadingMore = (state: DefaultRootState) =>
  state.acl.isLoadingMore;
export const getAclIsSavingName = (state: DefaultRootState) =>
  state.acl.isSavingName;
export const getRolesForInvite = (state: DefaultRootState) =>
  state.acl.inviteOptions.roles;
export const getGroupsForInvite = (state: DefaultRootState) =>
  state.acl.inviteOptions.groups;
export const getAclIsEditing = (state: DefaultRootState) => state.acl.isEditing;
export const getIconLocations = (state: DefaultRootState) =>
  state.acl.iconLocations;

/* for permissions - move these to their respective selectors file later */
export const getGroupPermissions = (state: DefaultRootState) => {
  const group = getSelectedGroup(state);

  return group?.userPermissions || [];
};

export const getRolePermissions = (state: DefaultRootState) => {
  const role = getSelectedRole(state);

  return role?.userPermissions || [];
};

export const getUserPermissions = (state: DefaultRootState) => {
  const user = getSelectedUser(state);

  return user?.userPermissions || [];
};
